import { Helpers } from '../../helpers';
import { IForecastType } from '../../interfaces/iforecast-type';
import { ForecastHorizontal } from '../forecast-horizontal';

export class ForecastTypeBase {
  ForecastTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_ForecastType?: Array<ForecastHorizontal> | null;

  constructor(item?: IForecastType) {
    if (item) {

      this.ForecastTypeId = item.ForecastTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_ForecastType = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_ForecastType);
    }
  }
}